import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import LogoutIcon from '@mui/icons-material/Logout';
import { useAuth } from 'react-oidc-context';

function LogoutButton() {
  const auth = useAuth();

  if (!auth?.isAuthenticated) return null;

  const handleLogout = () => {
    auth.signoutRedirect({
      post_logout_redirect_uri: window.location.origin + '/',
    });
  };

  return (
    <Tooltip title="Logout">
      <IconButton onClick={handleLogout} size="small" aria-label="Logout"
        sx={{ color: 'rgba(232,228,248,0.3)', '&:hover': { color: '#f87171', bgcolor: 'rgba(248,113,113,0.1)' } }}>
        <LogoutIcon sx={{ fontSize: 18 }} />
      </IconButton>
    </Tooltip>
  );
}

export default LogoutButton;
